// Globals
import { useTranslation } from 'react-i18next';

// Components
import { StyledContentBlock } from './OrdersListStyles';
import { getOrdersTableColumns } from './columns';
import { Table } from '@/ui';
import { Pagination } from '@/components';
import { OrdersFiltersContainer } from '../../containers';

// Modules
import { Resource, usePermissions } from '@/modules/Permissions';
import { selectAdminProfile } from '@/modules/AdminProfile';

// Store
import { useAppState } from '@/store';

// Models
import { Roles } from '@/models/admins.model';
import { IOrder } from '@/models/orders.model';

interface IOrdersListProps {
  ordersList: IOrder[];
  isLoading: boolean;
  currentPage: number;
  total: number;
  onPageChange: (page: number) => void;
}

const OrdersList = ({ ordersList, isLoading, currentPage, total, onPageChange }: IOrdersListProps) => {
  const { t } = useTranslation(['orders']);
  const profile = useAppState(selectAdminProfile);
  const { canManage } = usePermissions();
  // Manager column is shown to order processors (matches the manager filter): order.manage.
  const canManageOrderManager = canManage(Resource.ORDER);
  const isLogistician = profile?.role === Roles.LOGISTICIAN;
  const columns = getOrdersTableColumns(t, canManageOrderManager, !isLogistician);

  return (
    <StyledContentBlock>
      <Table
        className="orders-table"
        columns={columns}
        dataSource={ordersList || []}
        rowKey="id"
        loading={isLoading}
        scroll={{ x: 'max-content' }}
        components={{
          header: {
            wrapper: OrdersFiltersContainer,
          },
        }}
      />
      <Pagination current={currentPage} total={total} onChange={onPageChange} />
    </StyledContentBlock>
  );
};

export default OrdersList;
